import styled from 'styled-components';

interface Props {
  onMenteeInfo: boolean;
  onMenteeFile: boolean;
}
const Overlay = styled.div<Props>`
  position: absolute;
  top: 0;
  left: 0;
  width: ${(props) => (props.onMenteeInfo || props.onMenteeFile ? `calc(100% - 370px)` : '100vw')};
  height: 100vh;
`;

export default Overlay;
